import api from '../utils/api';
import { REQUEST_TEAM_API } from '../constants/routes';
import {
  TeamRequestCreateRequest,
  TeamRequestCreateResponse,
} from '../types/auth/teamRequest';

const HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';

export class TeamRequestDuplicateError extends Error {
  constructor(message = 'A request for this college is already pending.') {
    super(message);
    this.name = 'TeamRequestDuplicateError';
  }
}

export function resolveRequestTeamUrl(path?: string): string {
  if (!path) return REQUEST_TEAM_API;
  if (path.startsWith('http')) return path;
  if (path.startsWith('/')) return `${HOST}${path}`;
  return `${HOST}/${path}`;
}

export async function postTeamRequest(
  payload: TeamRequestCreateRequest,
  requestTeamPath?: string
): Promise<TeamRequestCreateResponse> {
  try {
    const response = await api.post<TeamRequestCreateResponse>(
      resolveRequestTeamUrl(requestTeamPath),
      payload
    );
    return response.data;
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    if (status === 409) {
      throw new TeamRequestDuplicateError();
    }
    throw err;
  }
}
